var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / notification_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.3818214%",
    y1: "91.566132%",
    x2: "29.5550878%",
    y2: "39.5398828%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCBCB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-notification_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification_app_tile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification",
    transform: "translate(7.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "3---Fill",
    fill: "#484848",
    opacity: 0.42,
    x: 6,
    y: 0,
    width: 63,
    height: 61,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "2---Fill",
    fill: "#484848",
    x: 3,
    y: 3,
    width: 69,
    height: 70,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,6 C73.209139,6 75,7.790861 75,10 L75,74 C75,76.209139 73.209139,78 71,78 L47.499,78 L37.5,88 L27.499,78 L4,78 C1.790861,78 1.15871992e-15,76.209139 0,74 L0,10 C-2.705415e-16,7.790861 1.790861,6 4,6 L71,6 Z",
    id: "MainNote---Fill",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,7 C71.8284271,7 72.5784271,7.33578644 73.1213203,7.87867966 C73.6642136,8.42157288 74,9.17157288 74,10 L74,10 L74,74 C74,74.8284271 73.6642136,75.5784271 73.1213203,76.1213203 C72.5784271,76.6642136 71.8284271,77 71,77 L71,77 L47.0857864,77 L37.5,86.5857864 L27.9142136,77 L4,77 C3.17157288,77 2.42157288,76.6642136 1.87867966,76.1213203 C1.33578644,75.5784271 1,74.8284271 1,74 L1,74 L1,10 C1,9.17157288 1.33578644,8.42157288 1.87867966,7.87867966 C2.42157288,7.33578644 3.17157288,7 4,7 L4,7 Z",
    id: "MainNote---Border",
    strokeOpacity: 0.433839598,
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("text", {
    id: "TXT_Count",
    fontFamily: ".AppleSystemUIFont",
    fontSize: 36,
    fontWeight: "normal",
    "line-spacing": 48
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationAppTile);
export default __webpack_public_path__ + "static/media/notification_app_tile.3cf129e64780d974d39cdec77eeaf9f9.svg";
export { ForwardRef as ReactComponent };